<!-- Standard Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{ modalTitle }}</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<div class="modal-body" [hidden]="minimise">
  @if (isLoading) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}
  @if (!isLoading) {
<form name="tbl3" novalidate>
    <div class="panel panel-default" style="margin-top:12px">
      <div class="panel-body">
        <div class="form-group">
          <div class="form-row">
            <div class="col-label">
              <label class="form-label" for="ME">ME/Business</label>
            </div>
            <div class="col-input me-dropdown">
              <ap-dropdown class="field-full-width" [list]="meOptions" [selectType]="'single'"
                inputId="ME" [title]="'ME/Business'" [hideTitleOnInput]="true" [inputAriaLabel]="'ME/Business'"
                [(ngModel)]="selectedMEItem" [ngModelOptions]="{standalone: true}"
                (onSelect)="onMEDropdownSelect($event)">
                @for (item of meOptions; track $index) {
                  <ap-dropdown-list-item #dropdownListItem [item]="item"
                    [ariaLabel]="setDropdownAriaLabel(item, 'ME/Business')"
                    (onSelectItem)="onMESelectItem($event)"></ap-dropdown-list-item>
                }
              </ap-dropdown>
            </div>
          </div>
          <div class="form-row">
            <div class="col-label">
              <label class="form-label" for="fs-accounts">Table 1 Category</label>
            </div>
            <div class="col-input fs-acc-dropdown">
              <ap-dropdown class="field-full-width" [list]="fsAccOptions" [selectType]="'single'"
                inputId="fs-accounts" [title]="'Table 1 Category'" [hideTitleOnInput]="true" [inputAriaLabel]="'Table 1 Category'"
                [disabled]="!meSelected"
                [(ngModel)]="selectedFSAccItem" [ngModelOptions]="{standalone: true}"
                (onSelect)="onFSAccDropdownSelect($event)">
                @for (item of fsAccOptions; track $index) {
                  <ap-dropdown-list-item #dropdownListItem [item]="item"
                    [ariaLabel]="setDropdownAriaLabel(item, 'Table 1 Category')"
                    (onSelectItem)="onFSAccSelectItem($event)"></ap-dropdown-list-item>
                }
              </ap-dropdown>
            </div>
          </div>
          <div class="form-row">
            <div class="col-label">
              <label class="form-label" for="varianceType">Variance Type</label>
            </div>
            <div class="col-input variance-type-dropdown">
              <ap-dropdown class="field-full-width" [list]="varianceTypeValues" [selectType]="'single'"
                inputId="varianceType" [title]="'Variance Type'" [hideTitleOnInput]="true" [inputAriaLabel]="'Variance Type'"
                [disabled]="!fsAcc"
                [(ngModel)]="selectedVarianceTypeItem" [ngModelOptions]="{standalone: true}"
                (onSelect)="onVarianceTypeDropdownSelect($event)">
                @for (item of varianceTypeValues; track $index) {
                  <ap-dropdown-list-item #dropdownListItem [item]="item"
                    [ariaLabel]="setDropdownAriaLabel(item, 'Variance Type')"
                    (onSelectItem)="onVarianceTypeSelectItem($event)"></ap-dropdown-list-item>
                }
              </ap-dropdown>
            </div>
          </div>
          <div class="form-row">
            <div class="col-label">
              <label class="form-label" for="comments">Comments</label>
            </div>
            <div class="col-input">
              <textarea class="form-control" id="comments" name="comments" rows="3" [ngModel]="comments" (ngModelChange)="onCommentsChange($event)" [disabled]="!typeSel || isLoading"></textarea>
            </div>
            @if (selectedVarianceType === 'Other') {
<div class="col-hint">
              Provide amount/details if Other variance is composed of more than one item
            </div>
}
          </div>
          <div class="form-row">
            <div class="col-label">
              <label class="form-label" for="amount1">Amount of Reconciling Item</label>
            </div>
            <div class="col-input">
              <input type="text"
                     id="amount1"
                     name="amount1"
                     [(ngModel)]="amount1"
                     onlyIntegersWithLength
                     [disabled]="!fsAcc || isLoading"
                     class="text-right form-control input-sm numText amount">
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
}
</div>

<div class="modal-footer" [hidden]="minimise">
  <button class="save-button" type="button" [disabled]="!typeSel || saveLoading" (click)="save()">
    @if (saveLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
  </button>
  <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
</div>
